/**
 * Created by: cparaschiv
 * Date: 27.05.2013, 18:23
 */

TS.ns('TS.domain.properties');

/**
 * @class TS.domain.properties.ValueProperty
 * @classdesc
 * @extends TS.Observable
 * @ignore
 */
TS.domain.properties.ValueProperty = new Class(
    /** @lends TS.domain.properties.ValueProperty # */
    {

        Extends: TS.Observable,

        mapping: {
            ignore: [],
            copy: ['Name', 'propertyType'],
            suppress: ['Name', 'propertyType']
        },

        //region Constructor

        initialize: function (domain, config) {
            var me = this;
            me.config = config;

            Object.append(me, ko.mapping.fromJS(config, this.getMappingOptions()));

            me.parent();
            me.Domain(domain);
        },

        getMappingOptions: function () {
            return this.mapping;
        },

        //endregion

        //region Properties

        //region Domain

        _Domain: null,

        Domain: function (value) {
            if (arguments.length === 0)
                return this._Domain;
            if (this._Domain !== value) {
                this._Domain && this.unhookDomain();
                this._Domain = value;
                this._Domain && this.hookDomain();
            }
        },

        hookDomain: function () {
        },

        unhookDomain: function () {
        },

        //endregion

        //endregion

        //region (Get)SetData
        /**
         * Returns an object containing values to be posted to server.
         * @protected
         */
        _getData: function () {
            var me = this,
                result = ko.mapping.toJS(me);

            $.each(me.mapping.suppress, function (idx, prop) {
                delete result[prop];
            });

            return result;
        },

        /**
         * Updates the property from the server response.
         * @method
         * @param {Object} config
         * @protected
         */
        _setData: function (data) {
            var me = this;
            ko.mapping.fromJS(data, me);
        },

        //endregion

        //region Dispose

        dispose: function () {
            var me = this;
            me.unhookDomain();
            me.parent();
        },

        //endregion

    });

TS.ObjectFactory.map('ValueProperty', TS.domain.properties.ValueProperty);